export default __webpack_public_path__ + "static/media/b01.f3e31226.jpg";